export const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="64"
      height="64"
      viewBox="0 0 172 172"
    >
      <g
        fill="none"
        fill-rule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
      >
        <path d="M0,172v-172h172v172z" fill="none"></path>
        <g fill="#F9A28F">
          <path d="M21.5,21.5v129h64.5v-32.25v-64.5v-32.25zM86,53.75c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25c-17.7805,0 -32.25,14.4695 -32.25,32.25zM118.25,86c-17.7805,0 -32.25,14.4695 -32.25,32.25c0,17.7805 14.4695,32.25 32.25,32.25c17.7805,0 32.25,-14.4695 32.25,-32.25c0,-17.7805 -14.4695,-32.25 -32.25,-32.25z"></path>
        </g>
      </g>
    </svg>
  );
};

export const DotIcon = () => {
  return (
    <svg
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
    </svg>
  );
};

export const LinkedinIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.09447 2.27483C3.09447 3.13908 2.40175 3.8397 1.54724 3.8397C0.692721 3.8397 0 3.13908 0 2.27483C0 1.41058 0.692721 0.709961 1.54724 0.709961C2.40175 0.709961 3.09447 1.41058 3.09447 2.27483ZM4.55426 13.7092V5.02611H7.11274V6.21352H7.1488C7.5045 5.53184 8.3743 4.81152 9.67192 4.81152C12.3747 4.81152 12.8725 6.60908 12.8725 8.94813V13.7099H10.2058V9.48675C10.2058 8.48032 10.1888 7.1849 8.8191 7.1849C7.43025 7.1849 7.21952 8.28218 7.21952 9.41522V13.7092H4.55426ZM2.88044 5.02611H0.210938V13.7092H2.88044V5.02611Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PhoneIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      fill="currentColor"
      width="800px"
      height="800px"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.748 5.773S11.418 5 10.914 5c-.496 0-.754.229-.926.387S6.938 7.91 6.938 7.91s-.837.731-.773 2.106c.054 1.375.323 3.332 1.719 6.058 1.386 2.72 4.855 6.876 7.047 8.337 0 0 2.031 1.558 3.921 2.191.549.173 1.647.398 1.903.398.26 0 .719 0 1.246-.385.536-.389 3.543-2.807 3.543-2.807s.736-.665-.119-1.438c-.859-.773-3.467-2.492-4.025-2.944-.559-.459-1.355-.257-1.699.054-.343.313-.956.828-1.031.893-.112.086-.419.365-.763.226-.438-.173-2.234-1.148-3.899-3.426-1.655-2.276-1.837-3.02-2.084-3.824a.56.56 0 0 1 .225-.657c.248-.172 1.161-.933 1.161-.933s.591-.583.344-1.27-1.906-4.716-1.906-4.716z" />
    </svg>
  );
};
export const GithubIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 0.894775C5.41702 0.894775 0.894775 5.42322 0.894775 11C0.894775 15.4665 3.79174 19.2505 7.80531 20.5904C8.30778 20.6835 8.49388 20.3733 8.49388 20.1004C8.49388 19.8584 8.48768 19.2257 8.48148 18.382C5.67136 18.99 5.07584 17.0297 5.07584 17.0297C4.61679 15.8635 3.95303 15.5533 3.95303 15.5533C3.03493 14.9268 4.02127 14.9392 4.02127 14.9392C5.03241 15.0136 5.5721 15.9813 5.5721 15.9813C6.47159 17.526 7.93558 17.0793 8.51249 16.8188C8.60554 16.1674 8.86608 15.7208 9.15144 15.4665C6.90582 15.2121 4.54855 14.3436 4.54855 10.4728C4.54855 9.36856 4.93936 8.46907 5.59071 7.76189C5.48526 7.50755 5.13787 6.47779 5.68997 5.08824C5.68997 5.08824 6.53983 4.8153 8.46907 6.1242C9.27551 5.90088 10.1378 5.78922 11 5.78302C11.8561 5.78922 12.7246 5.90088 13.531 6.1242C15.4602 4.8153 16.3101 5.08824 16.3101 5.08824C16.8622 6.47779 16.5148 7.50755 16.4094 7.76189C17.0545 8.46907 17.4453 9.36856 17.4453 10.4728C17.4453 14.3561 15.0818 15.2059 12.83 15.4602C13.1898 15.7704 13.5186 16.3908 13.5186 17.3337C13.5186 18.686 13.5062 19.7716 13.5062 20.1066C13.5062 20.3795 13.6861 20.6897 14.201 20.5904C18.2145 19.2505 21.1053 15.4665 21.1053 11.0062C21.1053 5.42322 16.5831 0.894775 11 0.894775Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const EmailIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      fill="currentColor"
      width="800px"
      height="800px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1920 428.266v1189.54l-464.16-580.146-88.203 70.585 468.679 585.904H83.684l468.679-585.904-88.202-70.585L0 1617.805V428.265l959.944 832.441L1920 428.266ZM1919.932 226v52.627l-959.943 832.44L.045 278.628V226h1919.887Z"
        fill-rule="evenodd"
      />
    </svg>
  );
};
